import { DisplayPosition } from '@/common/manager/position/display-position';
import { componentMap as formComponentMap } from '@cainiaofe/cn-ui';
import { calculateTextExprValue, executeFunction, makeButtons, } from '@/common/util/util';
import { ButtonPosition } from '@/common/manager/position/button-position';
const CnFormGrid = 'CnFormGrid';
export const config = {
    position: [DisplayPosition.formDialog, DisplayPosition.form],
    componentName: 'CnCard',
    formComponent: (props) => {
        const Component = formComponentMap.CnCard;
        return <Component shape="primary" {...props}/>;
    },
    isFormContainer: true,
    allowParentList: ['root', 'CnFormStepItem', 'CnFormTabItem'],
    formItemBeforeHandler: (formItem, config) => {
        const { formItemConfig = {}, formProps = {}, state, _context, urlParams, formValue, formInstance, getFormInstance, } = config || {};
        const { formStyle = {} } = formProps;
        const { cols, layoutMode } = formStyle || {};
        if (formItem) {
            const { label, name, options = {} } = formItemConfig;
            const { buttons = [] } = options;
            const componentProps = formItem['x-component-props'];
            if (componentProps) {
                if (componentProps.title) {
                    componentProps.title = calculateTextExprValue(componentProps.title, {
                        recordDataSource: formValue || {},
                        state,
                    });
                }
                if (label && !componentProps.title) {
                    componentProps.title = label;
                }
                if (componentProps.titleTips) {
                    componentProps.titleTips = calculateTextExprValue(componentProps.titleTips, {
                        recordDataSource: formValue || {},
                        state,
                    });
                }
                if (componentProps?.titleTag?.children) {
                    componentProps.titleTag.children = calculateTextExprValue(componentProps.titleTag.children, {
                        recordDataSource: formValue || {},
                        state,
                    });
                }
                if (componentProps?.titleTag && !componentProps?.titleTag?.children) {
                    componentProps.titleTag = null;
                }
                if (Array.isArray(buttons) && buttons.length > 0) {
                    const action = makeButtons({
                        buttons: buttons.map((item) => {
                            let realChildren = item?.children;
                            if (typeof item?.children === 'function') {
                                realChildren = executeFunction(item.children, formValue, state);
                            }
                            return {
                                ...item,
                                size: 'small',
                                position: ButtonPosition.cardAction,
                                children: realChildren,
                            };
                        }),
                        _context,
                        state,
                        urlParamsDataSource: urlParams,
                        recordDataSource: formValue,
                        formInstance,
                        getFormInstance,
                    });
                    if (action) {
                        componentProps.action = action;
                        delete componentProps.buttons;
                    }
                }
            }
            delete formItem['x-decorator'];
            formItem.properties = {};
            formItem.title = '';
            formItem.type = 'void';
            const { cols: cardCols, subCardCols } = componentProps;
            const formGridProps = {};
            if (cardCols) {
                formGridProps.cols = cardCols;
            }
            else {
                formGridProps.cols = cols;
            }
            const realLayoutComponent = layoutMode === 'single' ? 'CnFormSingleCol' : CnFormGrid;
            formItem.properties = {
                [`${name}_${CnFormGrid}`]: {
                    type: 'void',
                    'x-component': realLayoutComponent,
                    'x-component-props': formGridProps,
                    properties: {},
                },
                [`${name}_subCard_${CnFormGrid}`]: {
                    type: 'void',
                    'x-component': CnFormGrid,
                    'x-component-props': {
                        cols: subCardCols || 1,
                    },
                    properties: {},
                },
            };
        }
    },
};
